import { render, staticRenderFns } from "./KaijuFundsHistoryList.vue?vue&type=template&id=7c5b28f8&"
import script from "./KaijuFundsHistoryList.vue?vue&type=script&lang=ts&"
export * from "./KaijuFundsHistoryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports